import { components } from 'type/ReportServiceSchema';
import { BenchmarkType } from 'model/BenchmarkType';

export type BenchmarkRelativeScoreDto = components['schemas']['BenchmarkRelativeScore'];

export type BenchmarkRelativeScoreModel = {
  value?: number | null;
  label: string;
  type: BenchmarkType;
};

export const mapBenchmarkRelativeScoreDtoToModel = (
  dto: BenchmarkRelativeScoreDto
): BenchmarkRelativeScoreModel => ({
  value: dto.value,
  label: dto.label,
  type: dto.type as BenchmarkType,
});
